export default __webpack_public_path__ + "static/media/J724MANE1.906e14aa.pdf";